import Vue from "vue";
import Vuex from "vuex";
import Parse from "../plugins/parseConnect";
import axios from "axios";

Vue.prototype.$http = axios;

Vue.prototype.$Parse = Parse;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items_user: {
      watchlist: 0,
      watched: 0,
      visibility: "Watchlist",
      mustwatched: "Movies"
    },
    generalLanguage: "",
    generalGenres: "",
    generalMonths: "",
    generalCriteria: "",
    generalPlatforms: "",
    pageKidsMovies: 0,
    pageKidsSeries: 0,
    totalPagesMovies: 0,
    totalPagesSeries: 0,
    totalPagesMust: 0,
    pageWatched: 0,
    pageWatchlist: 0,
    pageArticles: 0,
    pageReviews: 0,
    platforms_full: null,
    platforms_temp: null,
    typeArticle: "getArticles",
    articlesArea: false,
    menuAsside: false,
    menuLeftAsside: false,
    languageModal: false,
    episodesModal: false,
    watchedLocal: [],
    watchlistLocal: [],
    episode: [],
    loginModal: false,
    forgotModal: false,
    banners: false,
    registerModal: false,
    ratingModal: false,
    alert: { color: "", message: "", active: false },
    user: { country: "USA" },
    show: { id: null, watched: "", watchlist: "" },
    movies: null,
    series: null,
    generalSortBy: null,
    moviesMustWatch: null,
    moviesRecommended: null,
    weekRelease: null,
    moviesRecommended_watched: {
      total: 0,
      watched: 0
    },

    title: { movies: "Movies", series: "Tv Shows" },
    showDetail: { recommendations: [], seasons: [], trailers: [] },
    seasons: [],
    pagination: 0,
    criteria: "",
    countMovies: 0,
    countSeries: 0,
    countMount: 0,
    paramsMovies: {
      imdbRange: "",
      genres: "",
      criteria: "",
      platforms: "",
      country: "USA",
      languages: "",
      sortBy: "",
      page: 0
    },
    paramsSeries: {
      imdbRange: "",
      genres: "",
      criteria: "",
      sortBy: "",
      platforms: "",
      country: "USA",
      languages: "",
      page: 0
    },
    paramsMust: {
      genres: "",
      criteria: "",
      platforms: "",
      country: "USA",
      language: "English",
      page: 0
    },
    pageRecommended: 0,
    totalPagesRecommended: 0,
    paramsRecommended: {
      country: "USA",
      recommendationsListId: "",
      page: 0
    }
  },
  mutations: {
    EDIT_CRITERIA(state, payload) {
      state.paramsMovies.criteria = payload;
      state.paramsSeries.criteria = payload;
      state.generalCriteria = payload;
    },
    EDIT_PARAMS_PLATFORMS(state, payload) {
      state.paramsMovies.platforms = payload;
      state.paramsSeries.platforms = payload;
      state.generalPlatforms = payload;
    },

    EDIT_PAGINATION_ARTICLES(state, payload) {
      state.pageArticles = payload;
    },
    TOGGLE_ARTICLESAREA(state) {
      state.articlesArea = !state.articlesArea;
    },

    TOGGLE_TYPEARTICLES(state) {
      state.typeArticle == "getArticles"
        ? (state.typeArticle = "getReviews")
        : (state.typeArticle = "getArticles");
    },
    EDIT_PAGINATION_REVIEWS(state, payload) {
      state.pageReviews = payload;
    },
    EDIT_PAGINATION_RECOMMENDED(state, payload) {
      state.paramsRecommended.page = payload;
      state.pageRecommended = payload;
    },
    EDIT_PAGINATION_MOVIE_KIDS(state, payload) {
      state.pageKidsMovies = payload;
    },
    EDIT_PAGINATION_WATCHED(state, payload) {
      state.pageWatched = payload;
    },
    EDIT_PAGINATION_WATCHLIST(state, payload) {
      state.pageWatchlist = payload;
    },
    EDIT_PAGINATION_SERIES_KIDS(state, payload) {
      state.pageKidsSeries = payload;
    },
    TOTAL_PAGES_MOVIES(state, payload) {
      state.totalPagesMovies = payload;
    },
    TOTAL_PAGES_SERIES(state, payload) {
      state.totalPagesSeries = payload;
    },
    TOTAL_PAGES_MUST(state, payload) {
      state.totalPagesMust = payload;
    },
    EDIT_GENRES(state, payload) {
      state.paramsMovies.genres = payload;
      state.paramsSeries.genres = payload;
      state.paramsMust.genres = payload;
      state.generalGenres = payload;
    },
    EDIT_LANGUAGES(state, payload) {
      state.generalLanguage = payload;
      state.paramsMovies.languages = payload;
      state.paramsSeries.languages = payload;
    },
    EDIT_LANGUAGE(state, payload) {
      if (payload == "") payload = "English";
      state.paramsMust.language = payload;
    },
    EDIT_SORT(state, payload) {
      state.paramsMovies.sortBy = payload;
      state.paramsSeries.sortBy = payload;
      state.generalSortBy = payload;
    },
    EDIT_ADS_BANNERS(state, payload) {
      state.banners = payload;
    },
    EDIT_ITEMS_WATCHLIST_SHOWS(state, payload) {
      state.items_user.watchlist = payload;
    },
    EDIT_ITEMS_WATCHED_SHOWS(state, payload) {
      state.items_user.watched = payload;
    },
    EDIT_ITEMS_VISIBILITY_WATCHED_SHOWS(state, payload) {
      state.items_user.visibility = payload;
    },
    EDIT_ITEMS_VISIBILITY_MUSTWATCHED_SHOWS(state, payload) {
      state.items_user.mustwatched = payload;
      state.paramsMust.page = 0;
    },
    CHANGE_COUNTRY(state, payload) {
      if (payload == undefined || payload == "undefined") payload = "USA";
      state.paramsMovies.country = payload;
      state.paramsSeries.country = payload;
      state.paramsMust.country = payload;
      state.user.country = payload;
      if (state.user.username != null) {
        var user = Parse.User.current();
        user.set("country", payload);
        user.save();
      }
      if (
        localStorage.getItem("OTT/Language/Guest") == "undefined" ||
        localStorage.getItem("OTT/Language/Guest") == null
      )
        localStorage.setItem("OTT/Language/Guest", payload);
    },
    CHANGE_NAME(state, payload) {
      state.user.name = payload;
    },

    editPlatformsActives(state, payload) {
      if (payload.length)
        for (let index = 0; index < state.platforms_full.length; index++) {
          for (let i = 0; i < payload.length; i++) {
            if (payload[i] == state.platforms_full[index].name) {
              state.platforms_full[index].backClass = "active";
              state.platforms_full[index].iconClass = "active-icon";
              break;
            } else {
              state.platforms_full[index].backClass = "";
              state.platforms_full[index].iconClass = "";
            }
          }
        }
    },
    editPlatformsFull(state, payload) {
      if (payload == "") {
        state.platforms_temp = state.platforms_full;
      } else {
        var p = state.platforms_full.filter(item =>
          item.name.toUpperCase().includes(payload.toUpperCase())
        );
        state.platforms_temp = p;
      }
    },
    EDIT_PLATFORMS(state, payload) {
      state.platforms_temp = payload;
      state.platforms_full = payload;
    },
    EDIT_IMAGE_PLATFORMS(state) {
      if (state.show.id != null && state.show.platforms.length > 0) {
        for (let index = 0; index < state.show.platforms.length; index++) {
          const a = state.show.platforms[index].platform.toUpperCase();
          if (state.platforms_full != null) {
            const i = state.platforms_full.findIndex(
              element => element.name.toUpperCase() == a
            );
            if (i != -1)
              state.show.platforms[index].platform =
                state.platforms_full[i].imageUrl;
          }
        }
      }
    },

    EDIT_SERIES(state, payload) {
      state.series = payload;
    },
    EDIT_MOVIES(state, payload) {
      state.movies = payload;
    },
    EDIT_MONTHS(state, payload) {
      state.generalMonths = payload;
    },
    EDIT_PAGINATION_MOVIES(state, payload) {
      state.paramsMovies.page = payload;
    },
    EDIT_PAGINATION_SERIES(state, payload) {
      state.paramsSeries.page = payload;
    },
    EDIT_PAGINATION_MUST(state, payload) {
      state.paramsMust.page = payload;
    },
    SET_RELEASING_THIS_WEEK(state, payload) {
      state.weekRelease = payload.map(function callback(currentValue) {
        const i = state.platforms_temp.findIndex(
          el => el.name == currentValue.platform
        );
        if (i != -1)
          currentValue.imgPlatform = state.platforms_temp[i].imageUrl;
        else currentValue.imgPlatform = null;
        return currentValue;
      });
    },
    EDIT_WATCHED_SHOW(state, payload) {
      let a = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        payload == false ||
        (payload == true && a.length != 5)
      ) {
        state.show.watched = payload;
        if (payload == true) state.show.watchlist = false;
      }
    },
    EDIT_INWATCHLIST_SHOW(state, payload) {
      let a = JSON.parse(localStorage.getItem("OTT/Watchlist/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        payload == false ||
        (payload == true && a.length != 5)
      ) {
        state.show.watchlist = payload;
        if (payload == true) state.show.watched = false;
      }
    },
    EDIT_WATCHED_SHOW_FORCE(state, payload) {
      state.show.watched = payload;
      if (payload == true) state.show.watchlist = false;
    },
    UPDATE_RATING(state, payload) {
      if (state.show.rating) state.show.rating = payload;
    },
    EDIT_INWATCHLIST_SHOW_FORCE(state, payload) {
      state.show.watchlist = payload;
      if (payload == true) state.show.watched = false;
    },
    EDIT_MUST_WATCHED_SHOW(state, payload) {
      const index = state.moviesMustWatch.findIndex(
        element => element.show.id === payload.id
      );
      let a = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        (payload.watched == false && a.length != 5) ||
        payload.watched == true
      )
        state.moviesMustWatch[index].show.watched = !state.moviesMustWatch[
          index
        ].show.watched;
      if (state.moviesMustWatch[index].show.watched == true)
        state.moviesMustWatch[index].show.watchlist = false;
    },
    EDIT_MUST_WATCHLIST_SHOW(state, payload) {
      const index = state.moviesMustWatch.findIndex(
        element => element.show.id === payload.id
      );
      let a = JSON.parse(localStorage.getItem("OTT/Watchlist/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        (payload.watchlist == false && a.length != 5) ||
        payload.watchlist == true
      )
        state.moviesMustWatch[index].show.watchlist = !state.moviesMustWatch[
          index
        ].show.watchlist;
      if (state.moviesMustWatch[index].show.watchlist == true)
        state.moviesMustWatch[index].show.watched = false;
    },
    EDIT_RECOMMENDED_WATCHED_SHOW(state, payload) {
      const index = state.moviesRecommended.findIndex(
        element => element.show.id === payload.id
      );
      let a = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        (payload.watched == false && a.length != 5) ||
        payload.watched == true
      )
        state.moviesRecommended[index].show.watched = !state.moviesRecommended[
          index
        ].show.watched;
      if (state.moviesRecommended[index].show.watched == true)
        state.moviesRecommended[index].show.watchlist = false;
    },
    EDIT_RECOMMENDED_WATCHLIST_SHOW(state, payload) {
      const index = state.moviesRecommended.findIndex(
        element => element.show.id === payload.id
      );
      let a = JSON.parse(localStorage.getItem("OTT/Watchlist/Guest"));
      if (a == null) a = [];
      if (
        state.user.username ||
        (payload.watchlist == false && a.length != 5) ||
        payload.watchlist == true
      )
        state.moviesRecommended[index].show.watchlist = !state
          .moviesRecommended[index].show.watchlist;
      if (state.moviesRecommended[index].show.watchlist == true)
        state.moviesRecommended[index].show.watched = false;
    },
    SET_WATCHED_LOCAL(state, payload) {
      if (payload != null) state.watchedLocal = payload;
      else state.watchedLocal = [];
    },
    SET_WATCHLIST_LOCAL(state, payload) {
      if (payload != null) state.watchlistLocal = payload;
      else state.watchlistLocal = [];
    },
    DELETE_WATCHLIST_ITEM(state, payload) {
      state.watchlistLocal.splice(payload, 1);
      const parsed = JSON.stringify(state.watchlistLocal);
      localStorage.setItem("OTT/Watchlist/Guest", parsed);
    },
    DELETE_WATCHED_ITEM(state, payload) {
      state.watchedLocal.splice(payload, 1);
      const parsed = JSON.stringify(state.watchedLocal);
      localStorage.setItem("OTT/Watched/Guest", parsed);
    },
    ADD_WATCHLIST_ITEM(state, payload) {
      if (state.watchlistLocal == null) state.watchlistLocal = [payload];
      else state.watchlistLocal.push(payload);
      const parsed = JSON.stringify(state.watchlistLocal);
      localStorage.setItem("OTT/Watchlist/Guest", parsed);
    },
    ADD_WATCHED_ITEM(state, payload) {
      if (state.watchedLocal == null) state.watchedLocal = [payload];
      else state.watchedLocal.push(payload);
      const parsed = JSON.stringify(state.watchedLocal);
      localStorage.setItem("OTT/Watched/Guest", parsed);
    },

    EDIT_LIKED_SHOW(state, payload) {
      state.show.liked = payload;
    },
    EDIT_IMDB(state, payload) {
      state.paramsMovies.imdbRange = payload;
      state.paramsSeries.imdbRange = payload;
    },

    EDIT_SHOW(state, payload) {
      state.show = payload;

      if (state.show.platforms != null)
        for (let index = 0; index < state.show.platforms.length; index++) {
          const a = state.show.platforms[index].platform.toUpperCase();
          if (state.platforms_full != null) {
            const i = state.platforms_full.findIndex(
              element => element.name.toUpperCase() == a
            );
            if (i != -1)
              state.show.platforms[index].platform =
                state.platforms_full[i].imageUrl;
          }
        }
    },
    editShowDetail(state, payload) {
      state.showDetail = payload;

      if (state.showDetail.seasons != "") {
        state.seasons = state.showDetail.seasons.map(function(s) {
          return s.title;
        });
      } else {
        state.seasons = [];
      }
      if (state.showDetail.trailers != "") {
        for (let i in state.showDetail.trailers) {
          state.showDetail.trailers[i] = state.showDetail.trailers[i].replace(
            "watch?v=",
            "embed/"
          );
        }
      }
      if (state.showDetail.recommendations != "") {
        state.showDetail.recommendations = state.showDetail.recommendations.map(
          function(obj) {
            const searchRegExp = /\s/g;
            const replaceWith = "-";
            obj.slug = obj.title.replace(searchRegExp, replaceWith);
            return obj;
          }
        );
      }
    },
    resetShowDetail(state) {
      state.show = null;
      state.showDetail = [];
      state.seasons = [];
    },
    RESET_SHOW(state) {
      state.show = null;
      state.showDetail = [];
      state.seasons = [];
    },

    TOGGLE_MENU_ASSIDE(state) {
      state.menuAsside = !state.menuAsside;
      state.menuAsside ? (state.menuLeftAsside = false) : null;
    },
    TOGGLE_TITLE(state, payload) {
      if (payload == "default") {
        state.title.movies = "Trending Movies";
        state.title.series = "Trending Tv Shows";
      } else {
        state.title.movies = "Movies";
        state.title.series = "Tv Shows";
      }
    },
    TOGGLE_MENU_LEFT_ASSIDE(state) {
      state.menuLeftAsside = !state.menuLeftAsside;
      state.menuLeftAsside ? (state.menuAsside = false) : null;
    },
    toggleLoginModal(state) {
      state.loginModal = !state.loginModal;
    },
    TOGGLE_EPISODES_MODAL(state, payload) {
      state.episodesModal = !state.episodesModal;
      state.episode = payload;
    },
    TOGGLE_MENU_LANGUAGE(state) {
      state.languageModal = !state.languageModal;
    },
    toggleForgotModal(state) {
      state.forgotModal = !state.forgotModal;
    },
    toggleRegisterModal(state) {
      state.registerModal = !state.registerModal;
    },
    toggleRatingModal(state) {
      state.ratingModal = !state.ratingModal;
    },
    DISABLED_MENU(state) {
      state.menuAsside = false;
      state.menuLeftAsside = false;
      state.loginModal = false;
      state.registerModal = false;
      state.forgotModal = false;
      state.episodesModal = false;
      state.ratingModal = false;
    },
    dataUser(state) {
      let localUser = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_PARSE_LOCAL_STORAGE)
      );
      state.user = localUser;
      if (
        !state.user.country ||
        state.user.country == undefined ||
        state.user.country == "undefined"
      )
        state.user.country = "USA";
    },
    userLocalSotrage(state, payload) {
      state.user = payload;
      if (
        !state.user.country ||
        state.user.country == undefined ||
        state.user.country == "undefined"
      )
        state.user.country = "USA";
    },
    signOutUser(state) {
      state.user = [];
      if (
        localStorage.getItem("OTT/Language/Guest") &&
        localStorage.getItem("OTT/Language/Guest") != undefined
      )
        state.user.country = localStorage.getItem("OTT/Language/Guest");
      else state.user.country = "USA";
    },
    closeAlert(state) {
      state.alert.active = false;
      state.alert.color = "";
      state.alert.message = "";
    },
    editAlert(state, payload) {
      state.alert.color = payload.color;
      state.alert.message = payload.message;
      state.alert.active = true;
      setTimeout(() => {
        state.alert.active = false;
        state.alert.color = "";
        state.alert.message = "";
      }, 3000);
    },
    SUM_COUNT_MOVIES: state => state.countMovies++,
    SUM_RECOMMENDED_WATCHED: state => state.moviesRecommended_watched.watched++,
    SUM_COUNT_SERIES: state => state.countSeries++,
    SUM_COUNT_MOUNT: state => state.countMount++
  },
  actions: {
    FETCH_MOVIES_PAGINATION: ({ commit, dispatch }, payload) => {
      switch (payload.key) {
        case "movies":
          commit("EDIT_PAGINATION_MOVIES", payload.id);
          commit("EDIT_MOVIES", null);
          dispatch("FETCH_MOVIES");
          break;
        case "series":
          commit("EDIT_PAGINATION_SERIES", payload.id);
          commit("EDIT_SERIES", null);
          dispatch("FETCH_SERIES");
          break;

        case "MovieKids":
          commit("EDIT_PAGINATION_MOVIE_KIDS", payload.id);
          break;

        case "SerieKids":
          commit("EDIT_PAGINATION_SERIES_KIDS", payload.id);
          break;
        case "Watchlist":
          commit("EDIT_PAGINATION_WATCHLIST", payload.id);
          break;
        case "Watched":
          commit("EDIT_PAGINATION_WATCHED", payload.id);
          break;
        case "MustWatched":
          commit("EDIT_PAGINATION_MUST", payload.id);
          dispatch("FETCH_MUSTWATCHED");
          break;
        case "articles":
          commit("EDIT_PAGINATION_ARTICLES", payload.id);
          break;
        case "reviews":
          commit("EDIT_PAGINATION_REVIEWS", payload.id);
          break;
        case "Recommended":
          commit("EDIT_PAGINATION_RECOMMENDED", payload.id);
          dispatch("FETCH_RECOMMENDED", null);
          break;

        default:
          break;
      }
    },
    FETCH_EDIT_GENRES: ({ state, commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MOVIES", 0);
      commit("EDIT_PAGINATION_SERIES", 0);
      commit("EDIT_PAGINATION_MUST", 0);
      commit("EDIT_GENRES", payload.data);
      commit("EDIT_MOVIES", null);
      commit("EDIT_SERIES", null);
      if (payload.src == "MustWatch") dispatch("FETCH_MUSTWATCHED");
      if (payload.src == "Home") {
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        if (
          payload.data != "" ||
          state.paramsMovies.imdbRange != "" ||
          state.paramsMovies.genres != "" ||
          state.paramsMovies.criteria != "" ||
          state.paramsMovies.platforms != "" ||
          state.paramsMovies.languages != "" ||
          state.paramsMovies.sortBy != ""
        ) {
          dispatch("FETCH_MOVIES");
          dispatch("FETCH_SERIES");
        } else {
          dispatch("FETCH_MOVIES_DEFAULT");
          dispatch("FETCH_SERIES_DEFAULT");
        }
      }
    },
    FETCH_EDIT_LANGUAGES: ({ state, commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MOVIES", 0);
      commit("EDIT_PAGINATION_SERIES", 0);
      commit("EDIT_PAGINATION_MOVIE_KIDS", 0);
      commit("EDIT_PAGINATION_SERIES_KIDS", 0);
      commit("EDIT_LANGUAGES", payload.data);
      if (payload.src == "Home") {
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        if (
          payload.data != "" ||
          state.paramsMovies.imdbRange != "" ||
          state.paramsMovies.genres != "" ||
          state.paramsMovies.criteria != "" ||
          state.paramsMovies.platforms != "" ||
          state.paramsMovies.languages != "" ||
          state.paramsMovies.sortBy != ""
        ) {
          dispatch("FETCH_MOVIES");
          dispatch("FETCH_SERIES");
        } else {
          dispatch("FETCH_MOVIES_DEFAULT");
          dispatch("FETCH_SERIES_DEFAULT");
        }
      }
    },
    FETCH_EDIT_SORT: ({ commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MOVIES", 0);
      commit("EDIT_PAGINATION_SERIES", 0);
      commit("EDIT_PAGINATION_MOVIE_KIDS", 0);
      commit("EDIT_PAGINATION_SERIES_KIDS", 0);
      commit("EDIT_SORT", payload.data);
      if (payload.src == "Home") {
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        dispatch("FETCH_MOVIES");
        dispatch("FETCH_SERIES");
      }
    },

    FETCH_EDIT_LANGUAGE: ({ commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MUST", 0);
      commit("EDIT_LANGUAGE", payload.data);
      if (payload.src == "MustWatch") {
        dispatch("FETCH_MUSTWATCHED");
      }
    },

    FETCH_EDIT_PLATFORMS: ({ state, commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MOVIES", 0);
      commit("EDIT_PAGINATION_SERIES", 0);
      commit("EDIT_PAGINATION_MOVIE_KIDS", 0);
      commit("EDIT_PAGINATION_SERIES_KIDS", 0);
      commit("EDIT_PARAMS_PLATFORMS", payload.data);
      if (payload.src == "Home") {
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        if (
          payload.data != "" ||
          state.paramsMovies.imdbRange != "" ||
          state.paramsMovies.genres != "" ||
          state.paramsMovies.criteria != "" ||
          state.paramsMovies.platforms != "" ||
          state.paramsMovies.languages != "" ||
          state.paramsMovies.sortBy != ""
        ) {
          dispatch("FETCH_MOVIES");
          dispatch("FETCH_SERIES");
        } else {
          dispatch("FETCH_MOVIES_DEFAULT");
          dispatch("FETCH_SERIES_DEFAULT");
        }
      }
    },

    FETCH_EDIT_CRITERIA: ({ state, commit, dispatch }, payload) => {
      if (state.generalCriteria != payload) {
        commit("EDIT_PAGINATION_MOVIES", 0);
        commit("EDIT_PAGINATION_SERIES", 0);
        commit("EDIT_CRITERIA", payload);
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        if (
          payload != "" ||
          state.paramsMovies.imdbRange != "" ||
          state.paramsMovies.genres != "" ||
          state.paramsMovies.criteria != "" ||
          state.paramsMovies.platforms != "" ||
          state.paramsMovies.languages != "" ||
          state.paramsMovies.sortBy != ""
        ) {
          dispatch("FETCH_MOVIES");
          dispatch("FETCH_SERIES");
        } else {
          dispatch("FETCH_MOVIES_DEFAULT");
          dispatch("FETCH_SERIES_DEFAULT");
        }
      }
    },

    FETCH_EDIT_IMDB: ({ commit, dispatch }, payload) => {
      commit("EDIT_PAGINATION_MOVIES", 0);
      commit("EDIT_PAGINATION_SERIES", 0);
      commit("EDIT_IMDB", payload.data);
      if (payload.src == "Home") {
        commit("EDIT_MOVIES", null);
        commit("EDIT_SERIES", null);
        dispatch("FETCH_MOVIES");
        dispatch("FETCH_SERIES");
      }
    },

    FETCH_CANT_WATCH_WATCHLIST: ({ state, commit }) =>
      new Promise(() => {
        if (!state.user.username) {
          let watchedLocal = JSON.parse(
            localStorage.getItem("OTT/Watched/Guest")
          );
          if (watchedLocal != null)
            commit("EDIT_ITEMS_WATCHED_SHOWS", watchedLocal.length);

          let watchlistLocal = JSON.parse(
            localStorage.getItem("OTT/Watchlist/Guest")
          );
          if (watchlistLocal != null)
            commit("EDIT_ITEMS_WATCHLIST_SHOWS", watchlistLocal.length);
        } else {
          const params = { page: 0 };
          Parse.Cloud.run("getWatchlist", params).then(result => {
            commit("EDIT_ITEMS_WATCHLIST_SHOWS", result.count);
          });
          Parse.Cloud.run("getWatchedShows", params).then(result => {
            commit("EDIT_ITEMS_WATCHED_SHOWS", result.count);
          });
        }
      }),

    FETCH_MOVIES: ({ state, commit }) =>
      new Promise(() => {
        commit("SUM_COUNT_MOVIES");
        commit("TOGGLE_TITLE", "custom");
        let validador = state.countMovies;
        Parse.Cloud.run("getMovies", state.paramsMovies)
          .then(res => {
            if (validador == state.countMovies) {
              let items = res.items.map(function(obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.slug = obj.title.replace(searchRegExp, replaceWith);
                return obj;
              });

              commit("EDIT_MOVIES", items);
              commit("TOTAL_PAGES_MOVIES", res.totalPages);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }),
    FETCH_MOVIES_DEFAULT: ({ state, commit }) =>
      new Promise(() => {
        commit("SUM_COUNT_MOVIES");
        commit("TOGGLE_TITLE", "default");
        let validador = state.countMovies;
        Parse.Cloud.run("getFeaturedMovies", state.paramsMovies)
          .then(res => {
            if (validador == state.countMovies) {
              let items = res.items.map(function(obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.slug = obj.title.replace(searchRegExp, replaceWith);
                return obj;
              });

              commit("EDIT_MOVIES", items);
              commit("TOTAL_PAGES_MOVIES", 0);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }),
    FETCH_SERIES_DEFAULT: ({ state, commit }) =>
      new Promise(() => {
        commit("SUM_COUNT_SERIES");
        commit("TOGGLE_TITLE", "default");
        let validador = state.countMovies;
        Parse.Cloud.run("getFeaturedSeries", state.paramsMovies)
          .then(res => {
            if (validador == state.countMovies) {
              let items = res.items.map(function(obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.slug = obj.title.replace(searchRegExp, replaceWith);
                return obj;
              });

              commit("EDIT_SERIES", items);
              commit("TOTAL_PAGES_SERIES", 0);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }),
    FETCH_SERIES: ({ state, commit }) =>
      new Promise(() => {
        commit("SUM_COUNT_SERIES");
        commit("TOGGLE_TITLE", "custom");
        let validador = state.countSeries;
        Parse.Cloud.run("getSeries", state.paramsSeries)
          .then(res => {
            if (validador == state.countSeries) {
              let items = res.items.map(function(obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.slug = obj.title.replace(searchRegExp, replaceWith);
                return obj;
              });

              commit("EDIT_SERIES", items);
              commit("TOTAL_PAGES_SERIES", res.totalPages);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }),
    FETCH_MUSTWATCHED: ({ state, commit }) =>
      new Promise(() => {
        commit("SUM_COUNT_MOUNT");
        let validador = state.countMount;
        state.moviesMustWatch = null;
        if (state.items_user.mustwatched == "Movies") {
          Parse.Cloud.run("getMustwatchMovies", state.paramsMust)
            .then(res => {
              if (validador == state.countMount) {
                commit("TOTAL_PAGES_MUST", res.totalPages);
                if (!state.user.username) {
                  const watchlist = JSON.parse(
                    localStorage.getItem("OTT/Watchlist/Guest")
                  );
                  const watched = JSON.parse(
                    localStorage.getItem("OTT/Watched/Guest")
                  );
                  state.moviesMustWatch = res.movies.map(function callback(
                    currentValue
                  ) {
                    if (watched != null) {
                      let a = watched.findIndex(
                        e => e.showId == currentValue.show.id
                      );
                      if (a != -1) currentValue.show.watched = true;
                      else currentValue.show.watched = false;
                    } else currentValue.show.watched = false;
                    if (watchlist != null) {
                      let b = watchlist.findIndex(
                        e => e.showId == currentValue.show.id
                      );
                      if (b != -1) currentValue.show.watchlist = true;
                      else currentValue.show.watchlist = false;
                    } else currentValue.show.watchlist = false;
                    const searchRegExp = /\s/g;
                    const replaceWith = "-";
                    currentValue.show.slug = currentValue.show.title.replace(
                      searchRegExp,
                      replaceWith
                    );

                    return currentValue;
                  });
                } else {
                  state.moviesMustWatch = res.movies.map(function(obj) {
                    const searchRegExp = /\s/g;
                    const replaceWith = "-";
                    obj.show.slug = obj.show.title.replace(
                      searchRegExp,
                      replaceWith
                    );
                    return obj;
                  });
                }
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          Parse.Cloud.run("getMustwatchSeries", state.paramsMust)
            .then(res => {
              if (validador == state.countMount) {
                state.moviesMustWatch = res.series.map(function(obj) {
                  const searchRegExp = /\s/g;
                  const replaceWith = "-";
                  obj.show.slug = obj.show.title.replace(
                    searchRegExp,
                    replaceWith
                  );
                  return obj;
                });
                commit("TOTAL_PAGES_MUST", res.totalPages);
                if (!state.user.username) {
                  const watchlist = JSON.parse(
                    localStorage.getItem("OTT/Watchlist/Guest")
                  );
                  const watched = JSON.parse(
                    localStorage.getItem("OTT/Watched/Guest")
                  );
                  state.moviesMustWatch = res.series.map(function callback(
                    currentValue
                  ) {
                    if (watched != null) {
                      let a = watched.findIndex(
                        e => e.showId == currentValue.show.id
                      );
                      if (a != -1) currentValue.show.watched = true;
                      else currentValue.show.watched = false;
                    } else currentValue.show.watched = false;
                    if (watchlist != null) {
                      let b = watchlist.findIndex(
                        e => e.showId == currentValue.show.id
                      );
                      if (b != -1) currentValue.show.watchlist = true;
                      else currentValue.show.watchlist = false;
                    } else currentValue.show.watchlist = false;
                    const searchRegExp = /\s/g;
                    const replaceWith = "-";
                    currentValue.show.slug = currentValue.show.title.replace(
                      searchRegExp,
                      replaceWith
                    );

                    return currentValue;
                  });
                }
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      }),
    CALC_WATCHLIST_RECO: ({ state, commit }, payload) =>
      new Promise(() => {
        if (state.user.username) {
          (state.paramsRecommended.country = state.paramsMovies.country),
            (state.paramsRecommended.recommendationsListId = payload),
            Parse.Cloud.run("getRecommendations", state.paramsRecommended)
              .then(res => {
                state.moviesRecommended_watched.total =
                  res.totalRecommendations;
                state.moviesRecommended_watched.watched = res.totalWatched;
              })
              .catch(error => {
                console.log(error);
              });
        } else {
          const watched = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
          state.moviesRecommended_watched.watched = 0;
          watched.map(function callback(currentValue) {
            const index = state.moviesRecommended.findIndex(
              el => el.show.id == currentValue.showId
            );
            if (index != -1) commit("SUM_RECOMMENDED_WATCHED");
          });
        }
      }),
    FETCH_RECOMMENDED: ({ state, dispatch }, payload) =>
      new Promise(() => {
        state.paramsRecommended.country = state.paramsMovies.country;
        if (payload != null)
          state.paramsRecommended.recommendationsListId = payload;
        Parse.Cloud.run("getRecommendations", state.paramsRecommended)
          .then(res => {
            state.totalPagesRecommended = res.totalPages;
            state.paramsRecommended.page = res.page;
            state.moviesRecommended_watched.total = res.totalRecommendations;
            state.moviesRecommended_watched.watched = res.totalWatched;

            // commit("TOTAL_PAGES_MUST", 0);
            if (!state.user.username) {
              const watchlist = JSON.parse(
                localStorage.getItem("OTT/Watchlist/Guest")
              );
              const watched = JSON.parse(
                localStorage.getItem("OTT/Watched/Guest")
              );
              state.moviesRecommended = res.recommendations.map(
                function callback(currentValue) {
                  if (watched != null) {
                    let a = watched.findIndex(
                      e => e.showId == currentValue.show.id
                    );
                    if (a != -1) currentValue.show.watched = true;
                    else currentValue.show.watched = false;
                  } else currentValue.show.watched = false;
                  if (watchlist != null) {
                    let b = watchlist.findIndex(
                      e => e.showId == currentValue.show.id
                    );
                    if (b != -1) currentValue.show.watchlist = true;
                    else currentValue.show.watchlist = false;
                  } else currentValue.show.watchlist = false;
                  const searchRegExp = /\s/g;
                  const replaceWith = "-";
                  currentValue.show.slug = currentValue.show.title.replace(
                    searchRegExp,
                    replaceWith
                  );
                  return currentValue;
                }
              );
              dispatch("CALC_WATCHLIST_RECO");
            } else {
              state.moviesRecommended = res.recommendations.map(function(obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.show.slug = obj.show.title.replace(
                  searchRegExp,
                  replaceWith
                );
                return obj;
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }),
    FETCH_PLATFORMS: ({ state, commit }) =>
      new Promise(() => {
        let params = { country: state.paramsMovies.country };
        Parse.Cloud.run("getPlatforms", params)
          .then(res => {
            commit("EDIT_PLATFORMS", res);
            if (state.show.id != null) commit("EDIT_IMAGE_PLATFORMS");
          })
          .catch(error => {
            if (error.code == 209)
              localStorage.removeItem(process.env.VUE_APP_PARSE_LOCAL_STORAGE);
            commit("signOutUser");

            console.log(error);
          });
      }),
    FETCH_ADS_BANNERS: ({ commit }) =>
      new Promise(() => {
        Parse.Cloud.run("getBanners")
          .then(res => {
            commit("EDIT_ADS_BANNERS", res);
          })
          .catch(error => {
            console.log(error);
          });
      }),
    SET_COUNTRY: ({ state, commit, dispatch }, payload) => {
      if (state.user.username != null) {
        var user = Parse.User.current();
        user.set("country", payload);
        user.save();
      }
      localStorage.setItem("OTT/Language/Guest", payload);
      //lo hago con un setTimeout porque por mas q la promesa vuelva OK el cambio demora unos segundos en el backend
      setTimeout(() => {
        commit("CHANGE_COUNTRY", payload),
          commit("EDIT_MOVIES", null),
          commit("EDIT_SERIES", null);
        dispatch("FETCH_PLATFORMS");
        dispatch("FETCH_MUSTWATCHED");
        if (
          state.paramsMovies.imdbRange != "" ||
          state.paramsMovies.genres != "" ||
          state.paramsMovies.criteria != "" ||
          state.paramsMovies.platforms != "" ||
          state.paramsMovies.languages != "" ||
          state.paramsMovies.sortBy != ""
        ) {
          dispatch("FETCH_MOVIES");
          dispatch("FETCH_SERIES");
        } else {
          dispatch("FETCH_MOVIES_DEFAULT");
          dispatch("FETCH_SERIES_DEFAULT");
        }
      }, 2000);
    },
    SET_USERNAME: ({ commit }, payload) => {
      if (payload.name != null) {
        let user = Parse.User.current();
        user.set("name", payload.name);
        user.save();
      }
      setTimeout(() => {
        let userlocal = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_PARSE_LOCAL_STORAGE)
        );

        commit("dataUser", userlocal);
        location.reload();
      }, 2500);
    },
    SET_WATCHED: ({ state, commit, dispatch }, payload) => {
      if (!state.user.username) {
        const items = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
        commit("SET_WATCHED_LOCAL", items);
        const items2 = JSON.parse(localStorage.getItem("OTT/Watchlist/Guest"));
        commit("SET_WATCHLIST_LOCAL", items2);
        dispatch("ADD_WATCHED", payload);
      } else {
        const params = { showId: payload.id, watched: payload.watched };
        Parse.Cloud.run("setWatchedShow", params);
      }
    },
    SET_WATCHLIST: ({ state, commit, dispatch }, payload) => {
      if (!state.user.username) {
        const items = JSON.parse(localStorage.getItem("OTT/Watchlist/Guest"));
        commit("SET_WATCHLIST_LOCAL", items);
        const items2 = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
        commit("SET_WATCHED_LOCAL", items2);

        dispatch("ADD_WATCHLIST", payload);
      } else {
        const params = { showId: payload.id, inWatchlist: payload.watchlist };
        Parse.Cloud.run("setWatchlist", params);
      }
    },

    ADD_WATCHLIST: ({ state, commit }, payload) => {
      let item = {
        showId: payload.id,
        inWatchlist: payload.watchlist
      };
      if (state.watchlistLocal != null) {
        const index = state.watchlistLocal.findIndex(
          element => element.showId == payload.id
        );
        if (index != -1) {
          commit("DELETE_WATCHLIST_ITEM", index);
        } else if (state.watchlistLocal.length < 5) {
          if (state.watchedLocal != null) {
            const index2 = state.watchedLocal.findIndex(
              element => element.showId == payload.id
            );
            if (index2 != -1) commit("DELETE_WATCHED_ITEM", index2);
          }
          commit("ADD_WATCHLIST_ITEM", item);
        } else {
          let alert = [];
          alert.color = "#EF3D58";
          alert.message = "To keep adding more shows to the Watchlist, sign in";
          commit("editAlert", alert);
        }
      } else {
        commit("ADD_WATCHLIST_ITEM", item);
        if (state.watchedLocal != null) {
          const index2 = state.watchedLocal.findIndex(
            element => element.showId == payload.id
          );
          if (index2 != -1) commit("DELETE_WATCHED", index2);
        }
      }
    },

    ADD_WATCHED: ({ state, commit }, payload) => {
      let item = {
        showId: payload.id,
        watched: payload.watched
      };
      if (state.watchedLocal != null) {
        const index = state.watchedLocal.findIndex(
          element => element.showId == payload.id
        );
        if (index != -1) {
          commit("DELETE_WATCHED_ITEM", index);
        } else if (state.watchedLocal.length < 5) {
          if (state.watchlistLocal != null) {
            const index2 = state.watchlistLocal.findIndex(
              element => element.showId == payload.id
            );
            if (index2 != -1) commit("DELETE_WATCHLIST_ITEM", index2);
          }
          commit("ADD_WATCHED_ITEM", item);
        } else {
          let alert = [];
          alert.color = "#EF3D58";
          alert.message = "To keep adding more shows to the Watchlist, sign in";
          commit("editAlert", alert);
        }
      } else {
        commit("ADD_WATCHED_ITEM", item);
        if (state.watchlistLocal != null) {
          const index2 = state.watchlistLocal.findIndex(
            element => element.showId == payload.id
          );
          if (index2 != -1) commit("DELETE_WATCHLIST_ITEM", index2);
        }
      }
    }
  },

  modules: {}
});
